import { Typography } from '@mui/material';
import { BaseSwitch } from './formElements/switches/BaseSwitch';
import useModal from '@/hooks/use-modals';

interface CoverageSectionSelectionProps {
  isRequired: boolean;
  isDeclined: boolean;
  symbol: string;
  scope: string;
  onToggle: (enabled: boolean) => void;
  confirmationModalId?: string | null;
}

export const CoverageSectionSelection = ({
  isRequired,
  isDeclined,
  symbol,
  scope,
  onToggle,
  confirmationModalId,
}: CoverageSectionSelectionProps) => {
  const { getModal } = useModal();

  function handleToggleChange() {
    if (confirmationModalId && !isDeclined && !getModal(confirmationModalId)?.hasBeenOpened()) {
      getModal(confirmationModalId)?.open();
    } else {
      onToggle(isDeclined);
    }
  }

  if (isRequired) {
    return (
      <Typography
        variant='body2'
        color='text.secondary'
      >
        Required
      </Typography>
    );
  }

  return (
    <BaseSwitch
      checked={!isDeclined}
      onChange={handleToggleChange}
      id={`${symbol}-${scope}-declined`}
      fireAnalytics={false}
    />
  );
};
